import { ErrorPage } from '@wallyhealth/web-core'
import { useStandbyScheduleSlots } from './hooks'
import StandbyPage from './schedule'
import useQuery from 'hooks/useQuery'

const StandbyScheduleFlow = () => {
  const query = useQuery()
  const linkId = query.get('id')

  const {
    isSchedulingLinkInvalid,
    isSchedulingLinkUsed,
    isSchedulingLinkDisabled,
    isSchedulingLinkExpired
  } = useStandbyScheduleSlots({ linkId })

  if (isSchedulingLinkUsed) {
    return (
      <ErrorPage
        title="Hm..."
        description="Looks like this link has been used already."
      />
    )
  }

  if (isSchedulingLinkExpired) {
    return (
      <ErrorPage
        title="All spoken for!"
        description="There's no more availability for tomorrow but we'll send another message when more become available!"
      />
    )
  }

  if (isSchedulingLinkDisabled) {
    return (
      <ErrorPage
        title="Hm..."
        description="Looks like this link has been disabled."
      />
    )
  }

  if (!linkId || isSchedulingLinkInvalid) {
    return (
      <ErrorPage
        title="Hm..."
        description="That looks like an invalid link."
      />
    )
  }

  return (
    <StandbyPage linkId={linkId} />
  )
}

export default StandbyScheduleFlow
